import Axios from 'axios'
import {userTypeUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_user_types (context) {
    Axios.get(userTypeUrls.getAllUserTypes).then(function (response) {
      context.commit('GET_ALL_USER_TYPES', response.data)
    })
  },
  get_user_types (context, publicId) {
    Axios.get(userTypeUrls.getUserTypes + publicId).then(function (response) {
      context.commit('GET_USER_TYPES', response.data)
    })
  },
  get_user_type_features (context, publicId) {
    Axios.get(userTypeUrls.getUserTypeFeatures + publicId).then(function (response) {
      context.commit('GET_USER_TYPE_FEATURES', response.data)
    })
  },
  get_not_assigned_features (context, publicId) {
    Axios.get(userTypeUrls.getNotAssignedFeatures + publicId).then(function (response) {
      context.commit('GET_NOT_ASSIGNED_FEATURES', response.data)
    })
  },
  get_deleted_user_types (context) {
    Axios.get(userTypeUrls.getDeletedUserType).then(function (response) {
      context.commit('GET_DELETED_USER_TYPES', response.data)
    })
  },
  get_user_type (context, publicId) {
    Axios.get(userTypeUrls.getUserType + publicId).then(function (response) {
      context.commit('GET_USER_TYPE', response.data)
    })
  },
  post_user_type (context, data) {
    Axios.post(userTypeUrls.postUserType, data).then(function () {
      context.dispatch('get_all_user_types')
    }).catch(function (error) {
    })
  },
  update_user_type (context, data) {
    Axios.post(userTypeUrls.editUserType + data.public_id, data).then(function () {
      context.dispatch('get_all_user_types')
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
    })
  },
  delete_user_type (context, publicId) {
    Axios.delete(userTypeUrls.deleteUserType + publicId).then(function (response) {
      context.dispatch('get_all_user_types')
    })
  },
  restoreUserType (context, publicId) {
    Axios.get(userTypeUrls.restoreUserType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_USER_TYPES', response.data)
      router.push({
        name: 'Module.UserTypes'
      })
    })
  }
}
